import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import _regeneratorRuntime from "/home/ubuntu/Local-Stitch-Front/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/ubuntu/Local-Stitch-Front/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import React, { useState } from 'react';
import { useSelector } from 'store';
import SelectBranchesSlider from 'components/tour/components/SelectBranchesSlider';
import SelectedServiceSlider from 'components/tour/components/SelectedServiceSlider';
import { getAPIErrorMessage, digitString } from 'utils';
import moment from 'moment';
import { PostTourRequestAPI } from 'api/application';
import { AgreeMessage, CORRECT_DATE_MSG, CORRECT_PHONE_MSG, EMAIL_UNMATCH_MSG, PERSON_MINIMUM_MSG, RequiredMessage, SelectMessage } from 'constants/message';
import { isEmail, isPhone } from 'constants/reg';
import Calendar from 'react-calendar';
import { useRouter } from 'next/router';

var ModalTourRequest = function ModalTourRequest(_ref) {
  var closeModal = _ref.closeModal;
  var router = useRouter();
  var branches = useSelector(function (state) {
    return state.space.branches;
  }).results; // Post Value

  var _useState = useState(''),
      name = _useState[0],
      setName = _useState[1];

  var _useState2 = useState(''),
      phone = _useState2[0],
      setPhone = _useState2[1];

  var _useState3 = useState(''),
      email = _useState3[0],
      setEmail = _useState3[1];

  var selected_branches = useSelector(function (state) {
    return state.application.selected_branches;
  });
  var selected_service = useSelector(function (state) {
    return state.application.selected_service;
  });

  var _useState4 = useState('01'),
      person = _useState4[0],
      setPerson = _useState4[1];

  var _useState5 = useState(new Date()),
      date = _useState5[0],
      setDate = _useState5[1];

  var _useState6 = useState(false),
      open = _useState6[0],
      setOpen = _useState6[1];

  var _useState7 = useState(false),
      agree = _useState7[0],
      setAgree = _useState7[1]; // Help Value


  var _useState8 = useState(''),
      nameHelp = _useState8[0],
      setNameHelp = _useState8[1];

  var _useState9 = useState(''),
      phoneHelp = _useState9[0],
      setPhoneHelp = _useState9[1];

  var _useState10 = useState(''),
      emailHelp = _useState10[0],
      setEmailHelp = _useState10[1]; // onChange


  var onChangeName = function onChangeName(event) {
    return setName(event.target.value);
  };

  var onChangePhone = function onChangePhone(event) {
    return setPhone(event.target.value);
  };

  var onChangeEmail = function onChangeEmail(event) {
    return setEmail(event.target.value);
  };

  var onChangeAgree = function onChangeAgree(event) {
    return setAgree(event.target.checked);
  };

  var onChangePerson = function onChangePerson(event) {
    var value = event.target.value;

    if (!Number.isInteger(Number(value))) {
      setPerson('01');
      return;
    }

    var num = Number(value);

    if (num > 99) {
      setPerson('01');
      return;
    }

    setPerson(digitString(num, 2));
  };

  var onChangeCalendar = function onChangeCalendar(event) {
    setDate(event);
    setOpen(false);
  }; // onClick


  var clickPlusPerson = function clickPlusPerson() {
    var num = Number(person);
    if (num >= 99) return;
    setPerson(digitString(num + 1, 2));
  };

  var clickMinusPerson = function clickMinusPerson() {
    var num = Number(person);
    if (num <= 1) return;
    setPerson(digitString(num - 1, 2));
  };

  var clickRequest = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var TourRequest, response;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (validate()) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return");

            case 2:
              TourRequest = {
                name: name,
                phone_number: phone,
                email: email,
                branches_id_list: selected_branches,
                services_list: selected_service,
                num_members: Number(person),
                start_at: moment(date).format('YYYY-MM-DDThh:mm')
              };
              _context.next = 5;
              return PostTourRequestAPI(TourRequest);

            case 5:
              response = _context.sent;

              if (!(response.status >= 400)) {
                _context.next = 9;
                break;
              }

              alert(getAPIErrorMessage(response));
              return _context.abrupt("return");

            case 9:
              _context.next = 11;
              return router.push('/tour/request_complete');

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function clickRequest() {
      return _ref2.apply(this, arguments);
    };
  }();

  var clickCalendar = function clickCalendar() {
    return setOpen(!open);
  }; // validate


  var validate = function validate() {
    if (!name.length) {
      document.getElementById('name').focus();
      setNameHelp(RequiredMessage('이름'));
      return false;
    }

    setNameHelp('');

    if (!phone.length) {
      document.getElementById('tell').focus();
      setPhoneHelp(RequiredMessage('연락처'));
      return false;
    }

    setPhoneHelp('');

    if (!email.length) {
      document.getElementById('email').focus();
      setEmailHelp(RequiredMessage('이메일'));
      return false;
    }

    setEmailHelp('');

    if (!isPhone(phone)) {
      document.getElementById('tell').focus();
      setPhoneHelp(CORRECT_PHONE_MSG);
      return false;
    }

    setPhoneHelp('');

    if (!isEmail(email)) {
      document.getElementById('email').focus();
      setEmailHelp(EMAIL_UNMATCH_MSG);
      return false;
    }

    setEmailHelp('');

    if (!selected_branches.length) {
      document.getElementById('branch').focus();
      alert(SelectMessage('지점'));
      return false;
    }

    if (!selected_service.length) {
      document.getElementById('service').focus();
      alert(SelectMessage('서비스'));
      return false;
    }

    if (!Number(person)) {
      alert(PERSON_MINIMUM_MSG);
      return false;
    }

    if (!moment(date, 'YYYY.MM.DD', true).isValid()) {
      alert(CORRECT_DATE_MSG);
      return false;
    }

    if (!agree) {
      alert(AgreeMessage('주의사항'));
      return false;
    }

    return true;
  }; // Calendar Disabled


  var tileDisabled = function tileDisabled(_ref3) {
    var date = _ref3.date,
        view = _ref3.view;
    var today = new Date().setHours(0, 0, 0, 0);
    return date < today;
  };

  return /*#__PURE__*/_jsx("div", {
    className: "dimd-layer",
    children: /*#__PURE__*/_jsx("div", {
      className: "inner sz-type",
      children: /*#__PURE__*/_jsxs("section", {
        className: "invite-w",
        children: [/*#__PURE__*/_jsx("h1", {
          children: "\uD22C\uC5B4.\uC785\uC8FC\uBB38\uC758"
        }), /*#__PURE__*/_jsxs("div", {
          className: "form-w",
          children: [/*#__PURE__*/_jsxs("label", {
            htmlFor: "name",
            children: ["\uC774\uB984", /*#__PURE__*/_jsx("i", {
              className: "ness",
              children: /*#__PURE__*/_jsx("span", {
                children: "\uD544\uC218\uC785\uB825"
              })
            })]
          }), /*#__PURE__*/_jsx("input", {
            type: "text",
            id: "name",
            placeholder: "\uC774\uB984\uC744 \uC785\uB825\uD574\uC8FC\uC138\uC694",
            title: "\uC774\uB984\uC744 \uC785\uB825\uD574\uC8FC\uC138\uC694",
            value: name,
            onChange: onChangeName
          }), nameHelp !== '' ? /*#__PURE__*/_jsx("p", {
            className: "err",
            children: nameHelp
          }) : null, /*#__PURE__*/_jsxs("label", {
            htmlFor: "tell",
            children: ["\uC5F0\uB77D\uCC98", /*#__PURE__*/_jsx("i", {
              className: "ness",
              children: /*#__PURE__*/_jsx("span", {
                children: "\uD544\uC218\uC785\uB825"
              })
            })]
          }), /*#__PURE__*/_jsx("input", {
            type: "text",
            id: "tell",
            placeholder: "000-0000-0000",
            value: phone,
            onChange: onChangePhone
          }), phoneHelp !== '' ? /*#__PURE__*/_jsx("p", {
            className: "err",
            children: phoneHelp
          }) : null, /*#__PURE__*/_jsxs("label", {
            htmlFor: "email",
            children: ["\uC774\uBA54\uC77C", /*#__PURE__*/_jsx("i", {
              className: "ness",
              children: /*#__PURE__*/_jsx("span", {
                children: "\uD544\uC218\uC785\uB825"
              })
            })]
          }), /*#__PURE__*/_jsx("input", {
            type: "text",
            id: "email",
            placeholder: "mail@mail.com",
            value: email,
            onChange: onChangeEmail
          }), emailHelp !== '' ? /*#__PURE__*/_jsx("p", {
            className: "err",
            children: emailHelp
          }) : null, /*#__PURE__*/_jsxs("em", {
            className: "tit",
            id: "service",
            children: ["\uD76C\uB9DD \uC11C\uBE44\uC2A4 \uC720\uD615", /*#__PURE__*/_jsx("i", {
              className: "ness",
              children: /*#__PURE__*/_jsx("span", {
                children: "\uD544\uC218\uC785\uB825"
              })
            })]
          }), /*#__PURE__*/_jsx("p", {
            className: "in-desc",
            children: "\uC6D0\uD558\uC2DC\uB294 \uC11C\uBE44\uC2A4 \uC720\uD615\uC744 \uC120\uD0DD\uD574\uC8FC\uC138\uC694 (\uBCF5\uC218 \uC120\uD0DD \uAC00\uB2A5)"
          }), /*#__PURE__*/_jsx(SelectedServiceSlider, {}), /*#__PURE__*/_jsxs("em", {
            className: "tit",
            id: "branch",
            children: ["\uC774\uC6A9 \uD76C\uB9DD \uC9C0\uC810", /*#__PURE__*/_jsx("i", {
              className: "ness",
              children: /*#__PURE__*/_jsx("span", {
                children: "\uD544\uC218\uC785\uB825"
              })
            })]
          }), /*#__PURE__*/_jsxs("p", {
            className: "in-desc",
            children: ["\uC6D0\uD558\uC2DC\uB294 \uC9C0\uC810\uC744 \uC120\uD0DD\uD574\uC8FC\uC138\uC694 (\uBCF5\uC218 \uC120\uD0DD \uAC00\uB2A5)", /*#__PURE__*/_jsx("br", {}), "*OO: 1\uC778 \uC8FC\uAC70 \uACF5\uAC04\uC774 \uC788\uB294 \uC9C0\uC810\uC785\uB2C8\uB2E4."]
          }), /*#__PURE__*/_jsx(SelectBranchesSlider, {
            branches: branches
          }), /*#__PURE__*/_jsxs("em", {
            className: "tit",
            children: ["\uC774\uC6A9\uC778\uC6D0", /*#__PURE__*/_jsx("i", {
              className: "ness",
              children: /*#__PURE__*/_jsx("span", {
                children: "\uD544\uC218\uC785\uB825"
              })
            })]
          }), /*#__PURE__*/_jsx("div", {
            className: "count-w",
            children: /*#__PURE__*/_jsxs("div", {
              className: "count",
              children: [/*#__PURE__*/_jsx("input", {
                type: "text",
                value: digitString(Number(person), 2),
                onChange: onChangePerson
              }), /*#__PURE__*/_jsx("button", {
                type: "button",
                className: "ms",
                onClick: clickMinusPerson,
                children: /*#__PURE__*/_jsx("span", {
                  children: "\uB9C8\uC774\uB108\uC2A4"
                })
              }), /*#__PURE__*/_jsx("button", {
                type: "button",
                className: "ps",
                onClick: clickPlusPerson,
                children: /*#__PURE__*/_jsx("span", {
                  children: "\uD50C\uB7EC\uC2A4"
                })
              })]
            })
          }), /*#__PURE__*/_jsxs("label", {
            htmlFor: "hopSt",
            children: ["\uC774\uC6A9 \uD76C\uB9DD \uC2DC\uC791\uC77C", /*#__PURE__*/_jsx("i", {
              className: "ness",
              children: /*#__PURE__*/_jsx("span", {
                children: "\uD544\uC218\uC785\uB825"
              })
            })]
          }), /*#__PURE__*/_jsx("input", {
            type: "text",
            id: "hopSt",
            placeholder: "0000.00.00",
            value: moment(date).format('YYYY.MM.DD'),
            onClick: clickCalendar,
            readOnly: true,
            style: {
              cursor: 'pointer'
            }
          }), open ? /*#__PURE__*/_jsx(Calendar, {
            onChange: onChangeCalendar,
            value: date,
            tileDisabled: tileDisabled
          }) : null]
        }), /*#__PURE__*/_jsxs("div", {
          className: "agree-box",
          children: [/*#__PURE__*/_jsxs("p", {
            children: [/*#__PURE__*/_jsx("input", {
              type: "checkbox",
              id: "agr",
              checked: agree,
              onChange: onChangeAgree
            }), /*#__PURE__*/_jsx("label", {
              htmlFor: "agr",
              children: "\uC8FC\uC758\uC0AC\uD56D\uC744 \uD655\uC778\uD588\uC73C\uBA70 \uC544\uB798\uC758 \uB0B4\uC6A9\uC5D0 \uB3D9\uC758\uD569\uB2C8\uB2E4."
            })]
          }), /*#__PURE__*/_jsxs("ul", {
            children: [/*#__PURE__*/_jsx("li", {
              children: "\uC218\uC9D1\xB7\uC774\uC6A9 \uBAA9\uC801 : \uB85C\uCEEC\uC2A4\uD2F0\uCE58 \uD22C\uC5B4 \uBC0F \uC0C1\uB2F4"
            }), /*#__PURE__*/_jsx("li", {
              children: "\uC218\uC9D1\xB7\uC774\uC6A9 \uD56D\uBAA9 : \uC774\uB984, \uD734\uB300\uD3F0 \uBC88\uD638, \uC774\uBA54\uC77C \uC8FC\uC18C"
            }), /*#__PURE__*/_jsx("li", {
              children: "\uC218\uC9D1\xB7\uC774\uC6A9 \uAE30\uAC04 : \uC2E0\uCCAD\uC77C\uB85C\uBD80\uD130 \uD22C\uC5B4 \uBC0F \uC0C1\uB2F4\uC644\uB8CC\uC2DC\uAE4C\uC9C0"
            })]
          })]
        }), /*#__PURE__*/_jsx("div", {
          className: "ly-btn intype2",
          children: /*#__PURE__*/_jsx("a", {
            onClick: clickRequest,
            style: {
              cursor: 'pointer'
            },
            children: "\uBB38\uC758\uD558\uAE30"
          })
        }), /*#__PURE__*/_jsx("button", {
          type: "button",
          className: "btn-close",
          onClick: closeModal,
          children: /*#__PURE__*/_jsx("span", {
            children: "\uD31D\uC5C5 \uB2EB\uAE30"
          })
        })]
      })
    })
  });
};

export default ModalTourRequest;